export default __webpack_public_path__ + "static/media/Mp-MH-package.5a41e6ad.jpg";